<div class="bracket-container">
  <div class="bracket-scroll">
    <div class="bracket-round" *ngFor="let round of rounds; let ri = index">
      <div class="round-header">{{ round.name }}</div>
      <div class="round-matches">
        <div class="bracket-match-wrapper" *ngFor="let match of round.matches; let mi = index"
             [class.has-next-round]="ri < rounds.length - 1">
          <div class="bracket-match-card"
               [class.completed]="match.status === 'completed'"
               [class.live]="match.status === 'live'"
               [class.editing]="editingMatchId === match.id"
               (click)="startEdit(match)">

            <!-- Display mode -->
            <ng-container *ngIf="editingMatchId !== match.id">
              <div class="team-row" [class.winner]="isWinner(match, 'home')">
                <span class="team-name">{{ match.homeTeamName || 'TBD' }}</span>
                <span class="score">{{ match.homeScore ?? '-' }}</span>
              </div>
              <div class="divider"></div>
              <div class="team-row" [class.winner]="isWinner(match, 'away')">
                <span class="team-name">{{ match.awayTeamName || 'TBD' }}</span>
                <span class="score">{{ match.awayScore ?? '-' }}</span>
              </div>
              <div class="match-status" [class.status-live]="match.status === 'live'">
                {{ getStatusLabel(match) }}
              </div>
            </ng-container>

            <!-- Edit mode -->
            <ng-container *ngIf="editingMatchId === match.id">
              <div class="edit-form" (click)="$event.stopPropagation()">
                <div class="edit-team-row">
                  <span class="edit-team-name">{{ match.homeTeamName || 'TBD' }}</span>
                  <mat-form-field class="score-field" appearance="outline">
                    <input matInput type="number" [(ngModel)]="editForm.homeScore" placeholder="-">
                  </mat-form-field>
                </div>
                <div class="edit-team-row">
                  <span class="edit-team-name">{{ match.awayTeamName || 'TBD' }}</span>
                  <mat-form-field class="score-field" appearance="outline">
                    <input matInput type="number" [(ngModel)]="editForm.awayScore" placeholder="-">
                  </mat-form-field>
                </div>
                <mat-form-field class="status-field" appearance="outline">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="editForm.status">
                    <mat-option *ngFor="let s of matchStatuses" [value]="s">{{ s | titlecase }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="edit-actions">
                  <button mat-button color="warn" (click)="cancelEdit($event)" [disabled]="isSaving">Cancel</button>
                  <button mat-flat-button color="primary" (click)="saveEdit(match, $event)" [disabled]="isSaving">
                    {{ isSaving ? 'Saving...' : 'Save' }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Connector lines -->
          <div class="connector-right" *ngIf="ri < rounds.length - 1">
            <div class="connector-line" [class.connector-top]="mi % 2 === 0" [class.connector-bottom]="mi % 2 !== 0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
